import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

const Blog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <Outlet />;
};
export default Blog;
